import React from 'react'
import { Col, Layout, Row, Card } from 'antd'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { MainMenu } from '../layouts/components/MainMenu'
import { GeneralFooter } from '../layouts/components/GeneralFooter'
import { BigVisor } from '../layouts/components/BigVisor'
import { GeneralContainer } from '../layouts/components/GeneralContainer'
import { DownloadModule } from '../layouts/components/DownloadModule'
import { SubscribeNewsModule } from '../layouts/components/SubscribeNewsModule'
import { useGetHomeIndicators } from '../services/home-indicators.service'
import { HomeIndicatorCard } from '../layouts/components/HomeIndicatorCard'
import { useGetSettings } from '../services/settings.service'

const { Meta } = Card

export const Home: React.FC = () => {

  const homeIndicatorsRequest = useGetHomeIndicators()
  const homeIndicators = homeIndicatorsRequest.data || []

  const settingsRequest = useGetSettings()
  const showAtlas = settingsRequest.data?.atlas_enabled !== false

  return (
    <CustomLayout>
      <MainMenu />
      <BigVisor />
      <GeneralContainer>
        <Row gutter={[16, 40]}>
          <Col xs={24} md={15}>
            <h2>La transición a tu alcance</h2>
            <p>
              En OTEA queremos brindarte una información fiable, veraz y actualizada sobre la transición energética y
              la acción climática en España, un contenido estructurado de forma clara y de fácil acceso.
            </p>
          </Col>
          <Col xs={24} md={{ span: 8, offset: 1 }}>
            <Row gutter={[16, 16]}>
              <DownloadModule />
            </Row>
          </Col>
        </Row>
      </GeneralContainer>
      <GeneralContainer>
        <Row gutter={[26, 40]}>
          <Col xs={24}>
            <h2>Seguimiento de los objetivos del PNIEC</h2>
          </Col>
        </Row>
        <Row gutter={[16, 40]}>
          {homeIndicators.map(i => (
            <Col xs={24} md={12} xl={8} key={i.id}>
              <HomeIndicatorCard
                title={i.title}
                icon={i.attachment[0].url}
                firstYear={i.firstYear}
                firstValue={i.firstValue}
                secondYear={i.secondYear}
                secondValue={i.secondValue}
                description={i.description}
                url={i.url}
              />
            </Col>
          ))}
        </Row>
      </GeneralContainer>
      <GeneralContainer>
        <Row gutter={[26, 40]}>
          <Col xs={24}>
            <h2>Explora nuestra base de datos</h2>
          </Col>
        </Row>
        <Row gutter={[16, 40]} justify="center">
          <Col xs={24} md={showAtlas ? 5 : 6}>
            <Link to="/bdd/clima/emisiones-de-gases-de-efecto-invernadero/totales-brutas">
              <HomeCard cover={<img alt="Clima" src="/iconos/icono-clima.png" width="100px" height="61px" />}>
                <Meta title="Clima" />
              </HomeCard>
            </Link>
          </Col>
          <Col xs={24} md={showAtlas ? 5 : 6}>
            <Link to="/bdd/E1/E11">
              <HomeCard cover={<img alt="Energía" src="/iconos/icono-energia.png" width="100px" height="100px" />}>
                <Meta title="Energía" />
              </HomeCard>
            </Link>
          </Col>
          <Col xs={24} md={showAtlas ? 5 : 6}>
            <Link to="/bdd/D1/D11">
              <HomeCard cover={<img alt="Economía" src="/iconos/icono-economia.png" width="100px" height="71px" />}>
                <Meta title="Economía" />
              </HomeCard>
            </Link>
          </Col>
          <Col xs={24} md={showAtlas ? 5 : 6}>
            <Link to="/bdd/S1/S11">
              <HomeCard cover={<img alt="Sociedad" src="/iconos/icono-sociedad.png" width="100px" height="78" />}>
                <Meta title="Sociedad" />
              </HomeCard>
            </Link>
          </Col>
          {showAtlas && (
            <Col xs={24} md={4}>
              <Link to="/atlas">
                <HomeCard cover={<img alt="Atlas" src="/iconos/icono-atlas.png" width="100px" height="78" />}>
                  <Meta title="Atlas" />
                </HomeCard>
              </Link>
            </Col>
          )}
        </Row>
      </GeneralContainer>
      <GeneralContainer>
        <Row>
          <SubscribeNewsModule />
        </Row>
      </GeneralContainer>
      <GeneralFooter />
    </CustomLayout>
  )
}

const HomeCard = styled(Card)`
  text-align: center;
  padding: 10px;
  border-radius: 100px;
  border: 0;
  max-width: 180px;
  margin: 40px auto 0;
  display: flex;
  flex-direction: column;

  img {
    margin: 0 auto;
    width: 100px;
  }

  .ant-card-cover {
    display: flex;
    align-items: center;
    height: 100px;
  }
`

const CustomLayout = styled(Layout)`
  background: #fff;

  .home-indicators-legend {
    width: 100%;
    background-color: #f8f8f8;
    padding: 10px;
    border-radius: 5px;
    font-size: small;
    margin: 20px 0 30px;

    svg {
      position: relative;
      top: 5px;
    }
  }
`
